
import { getBaseInfo } from '@/api/xiqueClinc'
import { getaddlog } from '@/api/hgfw'
import config from '@/config/index'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { getNewslist } from '@/api/youzheng'
import img1 from '@/assets/xiqueClinc/d4.png'
import img2 from '@/assets/xiqueClinc/d5.png'
import img3 from '@/assets/xiqueClinc/d6.png'
export default {
directives: {
TransferDom
},
components: { XDialog },
data () {
return {
baseUrl: config.baseUrl,
obj: {},
showInfo: false,
showChannel: false,
doctorList: [{
img: img1,
name: '华山',
accountid: '29228',
title: '主任中医师',
introduce: '毕业于浙江中医学院，从医30余年，有丰富的临床经验，擅长治疗高脂血症、糖尿病、高血压等现代常见慢性疾病。对中医养生及治未病有较深的研究。',
show: false
}, {
img: img2,
name: '俞淼',
accountid: '36086',
title: '女性生殖健康资深调理专家',
introduce: '浙江大学医学院临床医学本科毕业，从事妇产科临床40年，擅长妇科炎症、宫颈疾病、不孕不育、乳腺疾病、卵巢囊肿等妇科疾病的诊断治疗。',
show: false
}, {
img: img3,
name: '吴荣升',
accountid: '33010',
title: '中国针灸学会会员，中国执业药师',
introduce: '毕业于浙江中医药大学，运动医学专家嫡传弟子，中国针灸学会会员，中国执业药师，熟悉药物的药理机制及传统中医药炮制。擅长运用正骨、理筋、针推等传统理疗方法与现代运动医学结合治疗腰腿痛、运动损伤、体态不正调整等。',
show: false
}],
newsList: [],
pageCurrent: 1,
moremsg: '点击加载更多',
nomore: false
}
},
mounted () {
this.getInfo()
this.addLog()
this.getNews()
},
computed: {
accountid () {
return this.$store.state.user.accountid
},

userCertType () {
return this.$store.state.user.userCertType
}
},
methods: {
getMore (index) {
this.$set(this.doctorList[index], 'show', !this.doctorList[index].show)
},
detail (id) {
this.$router.push({ name: 'yzDetail', params: { type: id } })
},
getNews () {
getNewslist({
pageCurrent: this.pageCurrent,
pageSize: 3,
CATEGORYCODE: 'cat12_01',
owner_type: config.owner_type,
searchValue: '',
docterPanduan: 1
}).then(res => {
if (res.obj.length > 0) {
this.newsList = [...this.newsList, ...res.obj]
this.moremsg = '点击加载更多'
} else {
this.moremsg = '没有更多了~'
this.nomore = true
}
})
},
loadmore () {
if (!this.nomore) {
this.moremsg = '正在加载中...'
this.pageCurrent++
this.getNews()
}
},
consult (index) {
this.$router.push({ name: 'xiqueClincZhuanjia', params: { id: index } })
},

addLog () {
getaddlog({
accountid: this.accountid,
moduleid: 1200,
submoduleid: 120118
})
},
getInfo () {

getBaseInfo({
clinicid: 1025
}).then(res => {
if (res.status === 'suc') {
this.obj = res.returnValue
}
})
}
}
}
